// extracted by mini-css-extract-plugin
export var inputContainer = "_p5-0";